import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as types from '../../types';
import styles from './ImpersonationBanner.module.scss';

export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const session = useSelector((state: types.AppState) => state.session);

  if (!session?.impersonating) {
    return null;
  }

  return (
    <div className={styles.banner}>
      {t('you_are_impersonating', {
        email: session.email,
        defaultValue: 'You are impersonating {email}',
      })}
    </div>
  );
}
